import { doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore'
import { db } from '../firebase'

const COLLECTION = 'codexLinkMappings'
const DOC_ID = 'default'

const EMPTY_MAPPINGS = {
  byTag: {},
  byComposer: {},
  byGenre: {},
  byStyle: {}
}

export const DEFAULT_CODEX_LINK_MAPPINGS = {
  byTag: {
    tonique: { codexEntryId: 'fiche-tonique' },
    sousdominante: { codexEntryId: 'fiche-sous-dominante' },
    dominante: { codexEntryId: 'fiche-dominante' },
    septieme: { codexEntryId: 'fiche-dominante' },
    demicadence: { codexEntryId: 'fiche-demi-cadence-parfaite', sectionId: 'demi-cadence' },
    cadenceparfaite: { codexEntryId: 'fiche-demi-cadence-parfaite', sectionId: 'cadence-parfaite' },
    cadenceplagale: { codexEntryId: 'fiche-cadence-plagale' },
    'cadence6/4': { codexEntryId: 'fiche-cadence-64' },
    cadencerompue: { codexEntryId: 'fiche-cadence-rompue' },
    cadenceimparfaite: { codexEntryId: 'fiche-ponctuation-musicale', sectionId: 'cadence-imparfaite' },
    progressionii_v_i: { codexEntryId: 'fiche-enchainements-typiques' },
    premierrenversement: { codexEntryId: 'fiche-renversements' },
    secondrenversement: { codexEntryId: 'fiche-renversements' },
    septiemepremierrenversement: { codexEntryId: 'fiche-renversements' },
    septiemesecondrenversement: { codexEntryId: 'fiche-renversements' },
    septiemetroisiemerenversement: { codexEntryId: 'fiche-renversements' },
    napolitaine: { codexEntryId: 'fiche-sixte-napolitaine' }
  },
  byComposer: {
    bach: { codexEntryId: 'note-compositeurs', sectionId: 'bach' },
    mozart: { codexEntryId: 'note-compositeurs', sectionId: 'mozart' },
    beethoven: { codexEntryId: 'note-compositeurs', sectionId: 'beethoven' },
    chopin: { codexEntryId: 'note-compositeurs', sectionId: 'chopin' }
  },
  byGenre: {
    symphonie: { codexEntryId: 'note-formes-genres', sectionId: 'symphonie' },
    concerto: { codexEntryId: 'note-formes-genres', sectionId: 'concerto' },
    sonate: { codexEntryId: 'note-formes-genres', sectionId: 'sonate' },
    opera: { codexEntryId: 'note-formes-genres', sectionId: 'opera' }
  },
  byStyle: {
    baroque: { codexEntryId: 'note-style-baroque' },
    classique: { codexEntryId: 'note-style-classique' },
    romantique: { codexEntryId: 'note-style-romantique' },
    moderne: { codexEntryId: 'note-style-moderne' }
  }
}

export function getEmptyCodexMappings() {
  return { ...EMPTY_MAPPINGS }
}

export async function getCodexLinkMappings() {
  const ref = doc(db, COLLECTION, DOC_ID)
  const snap = await getDoc(ref)
  if (!snap.exists()) return { ...EMPTY_MAPPINGS }
  const data = snap.data() || {}
  return {
    byTag: data.byTag || {},
    byComposer: data.byComposer || {},
    byGenre: data.byGenre || {},
    byStyle: data.byStyle || {}
  }
}

export async function saveCodexLinkMappings(mappings, actor = null) {
  const ref = doc(db, COLLECTION, DOC_ID)
  await setDoc(ref, {
    byTag: mappings?.byTag || {},
    byComposer: mappings?.byComposer || {},
    byGenre: mappings?.byGenre || {},
    byStyle: mappings?.byStyle || {},
    updatedAt: serverTimestamp(),
    updatedBy: actor?.uid || null
  }, { merge: true })
}

function normalizeKey(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '_')
}

export function mergeTagMappingsFromEntries(baseMappings, entries = []) {
  const next = {
    byTag: { ...(baseMappings?.byTag || {}) },
    byComposer: { ...(baseMappings?.byComposer || {}) },
    byGenre: { ...(baseMappings?.byGenre || {}) },
    byStyle: { ...(baseMappings?.byStyle || {}) }
  }

  for (const entry of entries) {
    const entryId = entry?.id
    if (!entryId) continue
    const tags = Array.isArray(entry?.relatedTags) ? entry.relatedTags : []
    for (const tag of tags) {
      const key = normalizeKey(tag)
      if (!key) continue
      // On respecte les mappings déjà configurés manuellement.
      if (!next.byTag[key]) {
        next.byTag[key] = { codexEntryId: entryId }
      }
    }
  }

  return next
}
